import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftteamsComponent } from './simple-icons-microsoftteams.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftteamsComponent ],
    exports:      [ SimpleIconsMicrosoftteamsComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftteamsModule {}
